document.addEventListener('DOMContentLoaded', function() {
  const carousel = document.querySelector('.layer_collection_carousel');
  const prev = document.querySelector('.layer_collection_prev');
  const next = document.querySelector('.layer_collection_next');

  let scrollAmount = 0;
  let scrollTotal = 0;

  prev.addEventListener('click', function(e) {
    e.preventDefault();
    const width = carousel.offsetWidth;
    const scrollWidth = carousel.scrollWidth;
    const maxScroll = scrollWidth - width;
    const step = 200;
    scrollAmount = Math.min(scrollAmount - step, 0);
    carousel.scrollTo({
      top: 0,
      left: scrollAmount,
      behavior: 'smooth'
    });
  });

  next.addEventListener('click', function(e) {
    e.preventDefault();
    const width = carousel.offsetWidth;
    const scrollWidth = carousel.scrollWidth;
    const maxScroll = scrollWidth - width;
    const step = 200;
    scrollAmount = Math.min(scrollAmount + step, maxScroll);
    carousel.scrollTo({
      top: 0,
      left: scrollAmount,
      behavior: 'smooth'
    });
  });
});